import { get } from '..';

const getTemplateGroups = () => get('templates/groups');

export default getTemplateGroups;
